import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export function ssecMiddleware(options) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var input, properties, _i, _properties, prop, value, valueForHash, hash;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                input = _objectSpread({}, args.input);
                properties = [{
                  target: "SSECustomerKey",
                  hash: "SSECustomerKeyMD5"
                }, {
                  target: "CopySourceSSECustomerKey",
                  hash: "CopySourceSSECustomerKeyMD5"
                }];
                _i = 0, _properties = properties;
              case 3:
                if (!(_i < _properties.length)) {
                  _context.next = 19;
                  break;
                }
                prop = _properties[_i];
                value = input[prop.target];
                if (!value) {
                  _context.next = 16;
                  break;
                }
                valueForHash = void 0;
                if (typeof value === "string") {
                  if (isValidBase64EncodedSSECustomerKey(value, options)) {
                    valueForHash = options.base64Decoder(value);
                  } else {
                    valueForHash = options.utf8Decoder(value);
                    input[prop.target] = options.base64Encoder(valueForHash);
                  }
                } else {
                  valueForHash = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : new Uint8Array(value);
                  input[prop.target] = options.base64Encoder(valueForHash);
                }
                hash = new options.md5();
                hash.update(valueForHash);
                _context.t0 = options;
                _context.next = 14;
                return hash.digest();
              case 14:
                _context.t1 = _context.sent;
                input[prop.hash] = _context.t0.base64Encoder.call(_context.t0, _context.t1);
              case 16:
                _i++;
                _context.next = 3;
                break;
              case 19:
                return _context.abrupt("return", next(_objectSpread(_objectSpread({}, args), {}, {
                  input: input
                })));
              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
}
export var ssecMiddlewareOptions = {
  name: "ssecMiddleware",
  step: "initialize",
  tags: ["SSE"],
  override: true
};
export var getSsecPlugin = function getSsecPlugin(config) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(ssecMiddleware(config), ssecMiddlewareOptions);
    }
  };
};
export function isValidBase64EncodedSSECustomerKey(str, options) {
  var base64Regex = /^(?:[A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  if (!base64Regex.test(str)) return false;
  try {
    var decodedBytes = options.base64Decoder(str);
    return decodedBytes.length === 32;
  } catch (_unused) {
    return false;
  }
}